module.exports = __webpack_public_path__ + "static/img/10.edfb7b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/eng/10.png
// module id = 35g3
// module chunks = 0